
import SignUpForm from './components/SignUpForm';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';

const SignUpWizard = () => {

    return (
        <AuthSimpleLayout>
            <SignUpForm layout="simple" isAdmin={false} />
        </AuthSimpleLayout>
    );
};

export default SignUpWizard;
